import { configureStore } from '@reduxjs/toolkit';
import configReducer from './slices/config';
import modalReducer from './slices/modal';
import signUpReducer from './slices/signUp';
import layoutReducer from './slices/layout';

export const store = configureStore({
  reducer: {
    config: configReducer,
    modal: modalReducer,
    signUp: signUpReducer,
    layout: layoutReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Tipos para el store
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
